import { AsyncPipe } from '@angular/common';
import { Component, DOCUMENT, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { SettingService } from '@app/services/setting.service';

@Component({
  selector: 'app-switch-back-button',
  templateUrl: './switch-back-button.component.html',
  imports: [NgbTooltip, AsyncPipe],
})
export class SwitchBackButtonComponent {
  private document = inject<Document>(DOCUMENT);
  private settingService = inject(SettingService);

  backButton$ = this.settingService.backButton$;

  switchTo(url: string) {
    //TODO: Switch logic
    this.document.location.href = url;
  }
}
